// extracted by mini-css-extract-plugin
export default {"main":"Loading_main__l2aDW","background":"Loading_background__or7tn","background-logo":"Loading_background-logo__Czm7S","bottom":"Loading_bottom__QC2Kp"};